<template>
  <CustomPage title="顾客贡献榜" color="black" bgcolor="white">
    <div slot="content" style="height: 100%">
      <div
        class="flex justify-between text-xs mx-3 mb-3"
        style="color: #666666"
      >
        <div
          class="rounded-full px-2"
          @click="activeTab = 0"
          :class="activeTab === 0 ? 'active' : ''"
        >
          今日
        </div>
        <div
          class="rounded-full px-2"
          @click="activeTab = 1"
          :class="activeTab === 1 ? 'active' : ''"
        >
          昨日
        </div>
        <div
          class="rounded-full px-2"
          @click="activeTab = 2"
          :class="activeTab === 2 ? 'active' : ''"
        >
          近7日
        </div>
        <div
          class="rounded-full px-2"
          @click="activeTab = 3"
          :class="activeTab === 3 ? 'active' : ''"
        >
          近30日
        </div>
        <Popover
          :offset="[0, 0]"
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
        >
          <template #reference>
            <div :class="activeTab === 5 ? 'font-semibold' : ''">
              {{ selectedAction
              }}<Icon class="transform rotate-90" name="play" color="#E82035" />
            </div>
          </template>
        </Popover>
      </div>
      <Tabs v-model="activeSort" class="border-t border-red-600">
        <Tab title="按消费金额"></Tab>
        <Tab title="按订单数"></Tab>
        <div class="rounded-xl heavyshadow overflow-hidden m-3 text-xxs">
          <div
            class="bg-red text-white flex justify-between px-3 py-2 text-center"
          >
            <div class="w-2/12">排名</div>
            <div class="w-5/12">顾客信息</div>
            <div class="w-3/12">消费金额</div>
            <div class="w-2/12">订单数</div>
          </div>
          <div class="px-3 text-center">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="flex justify-between items-center py-2"
            >
              <div class="w-2/12 text-xs">{{ index + 1 }}</div>
              <div class="flex w-5/12 justify-start pl-6">
                <div style="height: 22px; width: 22px" class="mr-1">
                  <img
                    class="w-full h-full rounded-full"
                    style="object-fit: cover"
                    :src="item.headImg || require('@/assets/setting/avatar.png')"
                  />
                </div>
                <span style="line-height: 22px">{{ item.customerName }}</span>
              </div>
              <div class="w-3/12">{{ item.amountTotal }}</div>
              <div class="w-2/12">{{ item.orderNum }}</div>
            </div>
            <div v-show="!list.length" class="my-3">暂无数据</div>
          </div>
        </div>
      </Tabs>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Popover, Icon, Tab, Tabs } from "vant";
import { getCustomerContri } from "./webApi";
export default {
  components: { CustomPage, Popover, Icon, Tab, Tabs },
  created() {
    this.getCustomerContri();
  },
  data() {
    return {
      activeTab: 0,
      activeSort: 0,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      currentYear: this.dayjs().year(),
      currentMonth: this.dayjs().month() + 1,
      selectedAction: this.dayjs().format("YYYY-MM"),
      list: [],
    };
  },
  methods: {
    onSelect(action) {
      this.activeTab = 5;
      this.selectedAction = action.text;
      this.getCustomerContri();
    },
    getCustomerContri() {
      let params = {
        dateType: null,
        parameter: null,
        sortColumn: this.activeSort ? "orderNUm" : "amountTotal",
      };
      switch (this.activeTab) {
        case 0:
          params.dateType = "today";
          break;
        case 1:
          params.dateType = "yesterDay";

          break;
        case 2:
          params.dateType = "recentWeek";

          break;
        case 3:
          params.dateType = "recentMonth";

          break;
        case 5:
          params.dateType = "certainMonth";
          params.parameter = this.selectedAction;

          break;

        default:
          break;
      }
      getCustomerContri(params).then(({ data }) => {
        this.list = data;
      });
    },
  },
  computed: {
    actions() {
      let temp = [];
      for (let i = 0; i < 12; i++) {
        if (this.currentMonth > i) {
          temp.push({
            text: this.dayjs(
              this.currentYear + "-" + (this.currentMonth - i)
            ).format("YYYY-MM"),
          });
        } else {
          temp.push({
            text: this.dayjs(
              this.currentYear - 1 + "-" + (this.currentMonth - i + 12)
            ).format("YYYY-MM"),
          });
        }
      }

      return temp;
    },
  },
  watch: {
    activeTab(value) {
      if (value < 5) this.getCustomerContri();
    },
    activeSort() {
      this.getCustomerContri();
    },
  },
};
</script>

<style lang="less" scoped>
.active {
  background-color: #e82035;
  color: white;
}
::v-deep .van-tab--active {
  font-weight: 600;
  color: #e82035;
}
</style>